/* @flow */
import cx from 'classnames';
import * as React from 'react';
import Token from 'components/Token';
import Text from 'components/Text';

import './styles/ComposerRecipientToken.scss';

export default class ComposerRecipientToken extends React.Component<*> {
  static propTypes = {
    children(props: Object, propName: string) {
      if (React.Children.count(props[propName]) !== 2) {
        return new Error('ComposerRecipientToken expects two child elements');
      }
      return undefined;
    },
  };

  render() {
    const { children, ...tokenProps } = this.props;

    const [avatar, text] = children;
    const styledAvatar = React.cloneElement(avatar, {
      className: cx('ComposerRecipientToken-avatar', avatar.props.className),
    });

    return (
      <Token className="ComposerRecipientToken" {...tokenProps}>
        <div className="ComposerRecipientToken-container">
          {styledAvatar}
          <Text className="ComposerRecipientToken-name">{text}</Text>
        </div>
      </Token>
    );
  }
}
